import React from "react";
import ModalBody from 'react-bootstrap/ModalBody'

function STCModalBody(props){

    return(
        <ModalBody
            style={props.style}
            className={props.className}
            onClick={props.onClick}

            as={props.as}
           
        >
            {props.children}
        </ModalBody>
    )
}
export default STCModalBody;